import React from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LineChart,
  Line,
} from "recharts";
import DATASET from "../../../tools";
const { COLORS, YEARS } = DATASET;
export default function Index({ data, type, scenarios }) {
  console.log(data);
  return (
    <ResponsiveContainer width="100%" height={600}>
      {type === "line" ? (
        <LineChart
          data={data.line}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="year" />
          <YAxis />
          <Tooltip formatter={(value) => `${value.toFixed(2)} kt`} />
          <Legend style={{ marginTop: 20 }} />
          {scenarios.map((sheet, index) => (
            <Line
              key={index}
              dot={false}
              type="monotone"
              dataKey={sheet}
              strokeWidth={"1.5"}
              strokeDasharray={"5 5"}
              stroke={COLORS[index]}
            />
          ))}
        </LineChart>
      ) : (
        <AreaChart
          data={data.area}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="year" />
          <YAxis />
          <Tooltip
            formatter={(value, name, props) => {
              let result = `${value[0]} (${+(value[1] - value[0]).toPrecision(
                3
              )} kt)`;
              return result;
            }}
          />
          <Legend style={{ marginTop: 20 }} />
          {scenarios.map((sheet, index) => (
            <Area
              key={index}
              type="monotone"
              dataKey={sheet}
              fill={COLORS[index]}
              stroke={COLORS[index]}
              strokeWidth={0}
              fillOpacity={1}
            />
          ))}
        </AreaChart>
      )}
    </ResponsiveContainer>
  );
}
